import React from 'react';
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';

import WithdrawalRequests from 'admin-moderator/containers/WithdrawalRequests';
import ProfilesList from 'admin-moderator/containers/ProfilesList';
import BillerUserPanel from 'admin-moderator/containers/BillerUserPanel';

import FormReportPopup from 'admin-moderator/components/FormReportPopup';

import Tab from 'components/Tab';

import RightColumn from 'styled/Page/RightColumn';
import Main from 'styled/Page/Main';

import CustomFilterWrapper from './CustomFilterWrapper';

const TABS = [{
  label: 'Запросы на вывод средств',
  filter: 'requests',
}, {
  label: 'Анкеты пользователей',
  filter: 'profiles',
}];

export class BillerPage extends React.PureComponent {
  state = {
    activeTab: TABS.find(item => item.filter === this.props.match.params.department),
    shouldTransactionsUpdate: false,
  }

  componentDidUpdate(prevProps) {
    if (this.props.match.params.department !== prevProps.match.params.department) {
      this.setState({ // eslint-disable-line react/no-did-update-set-state
        activeTab: TABS.find(item => item.filter === this.props.match.params.department),
      });
    }
  }

  handleTabChange = (activeTab) => {
    if (activeTab.filter === this.props.match.params.department) return;

    let route = `/biller/${activeTab.filter}`;
    if (activeTab.filter) route += '/status/created';

    this.props.history.push(route);
  }

  handleReward = () => {
    this.setState({ shouldTransactionsUpdate: true });
  }

  handleTransactionsUpdate = () => {
    this.setState({ shouldTransactionsUpdate: false });
  }

  render() {
    return (
      <Main>
        <Helmet><title>Монетизация</title></Helmet>

        <div style={{ padding: '0 32px', width: '100%' }}>
          <CustomFilterWrapper>
            <div>
              {TABS.map(tab => (
                <Tab
                  key={tab.filter}
                  tab={tab}
                  active={tab.filter === this.state.activeTab.filter}
                  onChange={this.handleTabChange}
                />
              ))}
            </div>

            <FormReportPopup />
          </CustomFilterWrapper>

          {this.state.activeTab === TABS[0] && (
            <WithdrawalRequests
              shouldTransactionsUpdate={this.state.shouldTransactionsUpdate}
              onTransactionsUpdate={this.handleTransactionsUpdate}
            />
          )}

          {this.state.activeTab === TABS[1] && <ProfilesList />}
        </div>

        <RightColumn>
          <Route
            path="/biller/:department(requests)/status/:status(created|processing,finished|rejected|failed,failed_by_notification)/:requestId/user/:userId"
            render={props => <BillerUserPanel onReward={this.handleReward} {...props} />}
            exact
          />

          <Route
            path="/biller/:department(profiles)/status/:status(created|accepted|rejected)/:profileId/user/:userId"
            render={props => <BillerUserPanel onReward={this.handleReward} {...props} />}
            exact
          />
        </RightColumn>
      </Main>
    );
  }
}

BillerPage.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      department: PropTypes.oneOf(['requests', 'profiles']),
      status: PropTypes.oneOf(['created', 'accepted', 'rejected', 'processing,finished', 'failed,failed_by_notification']),
    }),
  }),
  history: PropTypes.shape({ push: PropTypes.func }),
};

BillerPage.defaultProps = {
  match: { params: {} },
  history: { push: () => {} },
};

export default BillerPage;
